import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ReportService} from '../../../services/report.service';
import {MatDialog} from '@angular/material/dialog';
import {NotificationService} from '../../../services/notification.service';
import {CurrentUserService} from '../../../services/current-user.service';
import {UserDTO} from '../../../model/userDTO';
import {ReportStatusDTO} from '../../../model/reportStatusDTO';

@Component({
  selector: 'app-report-list-final',
  templateUrl: './report-list-final.component.html',
})
export class ReportListFinalComponent implements OnInit {

  reports: ReportStatusDTO[];
  user: UserDTO;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private notificationService: NotificationService,
              private reportService: ReportService,
              public dialog: MatDialog,
              private currentUserService: CurrentUserService,
              private translate: TranslateService) {
    translate.use('nl');
  }

  ngOnInit(): void {
    this.reportService.getFinalReportList().subscribe(reports => this.reports = reports);
    this.currentUserService.get().then(user => this.user = user);
  }

}
